// @ts-nocheck
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import Rating from 'components/base/Rating';
import ProductColorNav from 'components/navs/ProductColorNav';
import { productColorVariants } from 'data/e-commerce';
import { currencyFormat } from 'helpers/utils';
import ProductGallery from 'components/modules/e-commerce/ProductGallery';
import { useMemo, useState, useEffect } from 'react';
import { Badge, Col, Modal, Row, Stack } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import QuantityButtons from 'components/common/QuantityButtons';
import { faHeart } from '@fortawesome/free-regular-svg-icons';
import { faShareAlt, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { isAuth, getCookie } from 'helpers/helpers';
import axios from 'axios';

const ProductDescription = ({ product, getOtherVariant }) => {
  const [selectedVariantKey, setSelectedVariantKey] = useState('blue');
  const [quantity, setQuantity] = useState(1);
  const [images, setImages] = useState([]);
  let navigate = useNavigate();

  const selectedVariant = useMemo(() => {
    return productColorVariants.find(
      variant => variant.id === selectedVariantKey
    );
  }, [selectedVariantKey]);

  const deleteProduct = ean => {
    if (!isAuth()) {
    } else {
      const token = getCookie('token');

      axios({
        method: 'post',
        url: process.env.REACT_APP_PRODUCT_API + '/delete-one-product',
        data: { ean },
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => {
          if (response.status == '200') {
            setModalShow(false);
            navigate('/primedeco/product-table');
          } else {
            setModalShow(false);
          }
        })
        .catch(err => {
          console.log('err', err);
        });
    }
  };

  useEffect(() => {
    const imageArray = [];
    product &&
      product.datens &&
      product.datens[0] &&
      imageArray.push(product.datens[0].Tueroeffnung_Rechts_FRONT);
    product &&
      product.datens &&
      product.datens[0] &&
      imageArray.push(product.datens[0].Tueroeffnung_Rechts_HALF);
    product &&
      product.datens &&
      product.datens[0] &&
      imageArray.push(product.datens[0].Tueroeffnung_Rechts_MAGNET);
    product &&
      product.datens &&
      product.datens[0] &&
      imageArray.push(product.datens[0].Tueroeffnung_Rechts_OFFEN);
    product &&
      product.datens &&
      product.datens[0] &&
      imageArray.push(product.datens[0].Tueroeffnung_Rechts_OBEN);
    product &&
      product.datens &&
      product.datens[0] &&
      imageArray.push(product.datens[0].Tueroeffnung_Rechts_WAND);
    product &&
      product.datens &&
      product.datens[0] &&
      imageArray.push(product.datens[0].Tueroeffnung_Rechts_HINTEN);
    product &&
      product.datens &&
      product.datens[0] &&
      imageArray.push(product.datens[0].Tueroeffnung_Links_FRONT);
    product &&
      product.datens &&
      product.datens[0] &&
      imageArray.push(product.datens[0].Tueroeffnung_Links_HALF);
    product &&
      product.datens &&
      product.datens[0] &&
      imageArray.push(product.datens[0].Tueroeffnung_Links_MAGNET);
    product &&
      product.datens &&
      product.datens[0] &&
      imageArray.push(product.datens[0].Tueroeffnung_Links_OFFEN);
    product &&
      product.datens &&
      product.datens[0] &&
      imageArray.push(product.datens[0].Tueroeffnung_Links_OBEN);
    product &&
      product.datens &&
      product.datens[0] &&
      imageArray.push(product.datens[0].Tueroeffnung_Links_WAND);
    product &&
      product.datens &&
      product.datens[0] &&
      imageArray.push(product.datens[0].Tueroeffnung_Links_HINTEN);

    setImages(imageArray);
  }, [product]);

  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <Row className="g-5 mb-5 mb-lg-8">
        <Col xs={12} lg={6}>
          {images && <ProductGallery images={images} />}
          <div className="d-flex">
            <Link
              style={{ color: '#E5780B', width: '100%' }}
              to={`/primedeco/create-new?ean=${
                product &&
                product.datens &&
                product.datens[0] &&
                product.datens[0].EAN
              }`}
            >
              <Button
                variant="outline-primary"
                size="lg"
                className="rounded-pill w-100 me-7 px-2 px-sm-4 fs--1 fs-sm-0"
              >
                Werte anpassen
              </Button>
            </Link>
            <Button
              onClick={() => setModalShow(true)}
              variant="outline-warning"
              size="lg"
              className="rounded-pill w-100 ms-7 px-2 px-sm-4 fs--1 fs-sm-0"
            >
              Produkt löschen
            </Button>
          </div>
        </Col>
        <Col xs={12} lg={6}>
          <Stack className="justify-content-between h-100">
            <div className="mb-3">
              <h3 className="mb-3 lh-sm">{product && product.Titel_Deutsch}</h3>

              <div className="d-flex flex-wrap">
                <p className="text-primary fw-semibold mb-3">
                  Anzahl: {product && product.Anzahl_Deutsch}{' '}
                  <span
                    style={{ display: 'inline-block', width: '10px' }}
                  ></span>{' '}
                  Variante: {product && product.Variantennummer}/
                  {product && product.Anzahl_Varianten}
                  <span
                    style={{ display: 'inline-block', width: '10px' }}
                  ></span>
                </p>
                <div
                  style={{
                    display: 'inline-block',
                    cursor: 'pointer',
                    marginLeft: '12px'
                  }}
                  onClick={() =>
                    getOtherVariant(product.Bildnummer, product.Variantennummer)
                  }
                >
                  <Badge bg="primary"> Variante wechseln</Badge>
                </div>
              </div>
              <div className="d-flex flex-wrap align-items-start mb-3">
                <span className="badge bg-success fs-9 rounded-pill me-2 fw-semibold">
                  {product &&
                    product.datens &&
                    product.datens[0] &&
                    product.datens[0].Hauptkategorie}
                </span>
                <span className="fw-semibold">
                  {product && product.Variantenbezeichnung}
                </span>
              </div>
              {/* <div className="d-flex flex-wrap align-items-center">
              <h1 className="me-3">{currencyFormat(1349.99)}</h1>
              <p className="text-body-quaternary text-decoration-line-through fs-6 mb-0 me-3">
                {currencyFormat(1499.99)}
              </p>
            </div> */}
              <div>
                <p className="text-warning-dark fs-7 mb-0 mt-2">
                  Bildnummer:{' '}
                  {product &&
                    product.datens &&
                    product.datens[0] &&
                    product.datens[0].Bildnummer}
                </p>
                <p className="text-warning-dark fs-7 mb-0">
                  EAN:{' '}
                  {product &&
                    product.datens &&
                    product.datens[0] &&
                    product.datens[0].EAN}
                </p>
                <p className="text-warning-dark fs-7 mb-0">
                  SKU: {product && product.Eigene_SKU}
                </p>
                <p className="text-warning-dark fs-7 mb-0">
                  Motiv: {product && product.Motiv}
                </p>
              </div>
              <p className="fw-semibold text-success fs-7 mb-2 mt-2">
                Plenty Kategorie ID:{' '}
                {product &&
                  product.datens &&
                  product.datens[0] &&
                  product.datens[0].Plenty_Kategorie_ID}{' '}
              </p>
              <p className="fw-semibold mb-2 text-body">
                Farbe:{' '}
                <span className="text-body-emphasis">
                  {product &&
                    product.datens &&
                    product.datens[0] &&
                    product.datens[0].Farbe}
                </span>
              </p>
              <p className="mb-2 text-body-secondary">
                <span className="text-body-highlight">
                  {product &&
                    product.datens &&
                    product.datens[0] &&
                    product.datens[0].Name_EAN}
                </span>
              </p>
              {/*   <p className="text-success-dark fw-bold mb-5 mb-lg-0">
              {product &&
                product.datens &&
                product.ean_gtins[0] &&
                product.ean_gtins[0].Status}
            </p> */}
            </div>

            <div>
              <div className="mb-3">
                {/*  <ProductColorNav
                selectedVariantKey={selectedVariantKey}
                setSelectedVariantKey={setSelectedVariantKey}
              /> */}
              </div>
              {/* <div className="row g-3 g-sm-5 align-items-end">
              <div className="col-12 col-sm-auto">
                <p className="fw-semibold mb-2 text-body">Size : </p>
                <div className="d-flex align-items-center">
                  <select className="form-select w-auto">
                    <option value="44">44</option>
                    <option value="22">22</option>
                    <option value="18">18</option>
                  </select>
                  <a className="ms-2 fs-9 fw-semibold" href="#!">
                    Size chart
                  </a>
                </div>
              </div>
              <div className="col-12 col-sm">
                <p className="fw-semibold mb-2 text-body">Quantity : </p>
                <div className="d-flex justify-content-between align-items-end">
                  <QuantityButtons
                    quantity={quantity}
                    setQuantity={setQuantity}
                  />
                  <Button variant="phoenix-primary" className="px-3 border-0">
                    <FontAwesomeIcon icon={faShareAlt} className="fs-7" />
                  </Button>
                </div>
              </div>
            </div> */}
            </div>
          </Stack>
        </Col>
      </Row>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="xs"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Produkt wirklich löschen?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Dieser Vorgang kann nicht rückgängig gemacht werden.</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center">
            {product &&
            product.datens &&
            product.datens[0] &&
            product.datens[0].EAN ? (
              <Button
                variant="danger"
                className="me-1"
                onClick={e => deleteProduct(product.datens[0].EAN)}
              >
                Entgültig löschen
              </Button>
            ) : (
              'EAN nicht vorhanden'
            )}
            <Button onClick={() => setModalShow(false)}>Close</Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProductDescription;
